export default {
  titulo: "Purchases",
  nueva: "New purchase",
  buscar: "Search by document, supplier or part number",
  eliminar: "Delete purchase",
  pregEliminar: "Are you sure you want to delete the purchase?",
  editar: "Edit purchase",
  tipoDocumento: "Document type",
  ventaIgualCompra: "Set sale price equal to purchase price",
  observaciones: "Remarks",
  subtotal: "Subtotal",
  descuento: "Discount",
  iva: "Tax",
  redondeo: "Rounding",
  total: "Total",
  contado: "Cash",
  credito: "Credit",
  notaCred: "Credit note",
  devolucion: "Cash refund",
  msgRepuestos: "Add at least one spare part to continue",
  msgImpuestos: "Assign a valid tax to all spare parts to continue",
  msgDuplicado: "Duplicate spare part",
  msgCantidad: "Enter a valid quantity"
}
